import { DateTime } from "luxon";

// export function getFormattedDate(input) {
// 	const date = new Date(input);

// 	const dateString =
// 		("00" + date.getDate()).slice(-2) +
// 		"-" +
// 		("00" + (parseInt(date.getMonth()) + 1)).slice(-2) +
// 		"-" +
// 		date.getFullYear() +
// 		" " +
// 		getMinutesString(date.getHours(), date.getMinutes());

// 	return dateString;
// }

// function getMinutesString(hour, minutes) {
// 	let result = "";
// 	let m = ":" + ("00" + minutes).slice(-2);

// 	if (parseInt(hour) > 12) {
// 		result = ("00" + (hour - 12)).slice(-2) + m + " PM";
// 	} else {
// 		result = ("00" + hour).slice(-2) + m + " AM";
// 	}

// 	return result;
// }

export function getLuxonDate(input) {
	const date = DateTime.fromISO(input);
	return date.toFormat("dd-MM-yyyy hh:mm a");
}
